import React from "react";

import { IonSpinner } from "@ionic/react";

import "./Loading.css";

interface LoadingProps {
  show: boolean;
}

const Loading: React.FC<LoadingProps> = ({ show }) => {
  if (!show) {
    return null;
  }
  return (
    <div className="ui-loading">
      <IonSpinner />
      <span>Carregando...</span>
    </div>
  );
};

export default Loading;
